// extracted by mini-css-extract-plugin
export default {"bigMessage":"bigMessage-rlzXx"};